(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('EmployeePhone', EmployeePhone);

    EmployeePhone.$inject = ['$resource', 'DateUtils'];

    function EmployeePhone ($resource, DateUtils) {
        var resourceUrl =  'api/employee-phones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bindingTime = DateUtils.convertDateTimeFromServer(data.bindingTime);
                        data.unbindingTime = DateUtils.convertDateTimeFromServer(data.unbindingTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
